import SuggestionCardHeader, {
  SuggestionCardHeaderProps,
} from './SuggestionCardHeader';

export default SuggestionCardHeader;
export type { SuggestionCardHeaderProps };
